module.exports = __webpack_public_path__ + "static/media/500.8d36276b.svg";